:host {
  display: block;
  font-family: var(--ls-font-family);
  width: var(--ls-indicator-width, 150px);
  height: var(--ls-indicator-height, 96px);
  position: absolute;
}

.label{
  font-size: var(--ls-indicator-label-size, var(--ls-text-base));
  line-height: var(--ls-indicator-label-line-height, var(--ls-line-base));
}

.backdrop, .indicator{
  font-family: "Digital";
  font-size: var(--ls-indicator-digit-size, 5rem);
  line-height: var(--ls-indicator-digit-line-height, 80px);
  width: var(--ls-indicator-digit-width, 75px);
  letter-spacing: var(--ls-indicator-letter-spacing, 0.05rem);
  position: absolute;
  bottom: 0;
  color: var(--ls-primary-color);
}

.backdrop{
  opacity: 0.1;
}

.indicator {
  text-align: right;
  left: 0;
}
